import isEmpty from 'lodash-es/isEmpty';

export const BLANK_PAGE_TITLE = '$name';

export const isBlankPageTitle = (pageTitle: string | null) => {
  return isEmpty(pageTitle) || BLANK_PAGE_TITLE === pageTitle;
};
